import omit from "lodash/omit";

function getAlwaysVisibleFieldCount(workOrderLayoutSettings) {
  const { itemCode, itemDescription } = workOrderLayoutSettings;
  const productionFields = 3;
  const alwaysVisibleFields = 1;

  return [itemCode, itemDescription].filter((val) => val === true).length + productionFields + alwaysVisibleFields;
}
function getExpandedFieldCount(workOrderLayoutSetting) {
  const expandedFieldSettings = omit(workOrderLayoutSetting, [
    "itemCode",
    "itemDescription",
    "customWorkOrderFields",
    "__typename",
  ]);

  const booleanFieldCount = Object.values(expandedFieldSettings).filter((val) => val === true).length;
  const customFieldCount = workOrderLayoutSetting.customWorkOrderFields?.filter((f) => f.enabled).length ?? 0;

  return booleanFieldCount + customFieldCount;
}

function getWorkOrderPriorityLabel(workOrderPriority) {
  if (!workOrderPriority) return "";

  return workOrderPriority.description
    ? `${workOrderPriority.priority} - ${workOrderPriority.description}`
    : workOrderPriority.priority;
}

export { getAlwaysVisibleFieldCount, getExpandedFieldCount, getWorkOrderPriorityLabel };
